import { render, staticRenderFns } from "./assigningList.vue?vue&type=template&id=446ad1a0&"
import script from "./assigningList.vue?vue&type=script&lang=js&"
export * from "./assigningList.vue?vue&type=script&lang=js&"
import style0 from "./assigningList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports